// <zzy-feature-gate feature="module.briefing"><slot></slot></zzy-feature-gate>
import { fetchJson } from '../http.js';

const _cache = new Map();

async function hasFeature(featureKey) {
  if (_cache.has(featureKey)) return _cache.get(featureKey);
  try {
    const r = await fetchJson('/rpc/fn_has_feature', {
      method: 'POST',
      body: { p_feature: featureKey }
    });
    const v = !!r;
    _cache.set(featureKey, v);
    return v;
  } catch (err) {
    console.warn('[feature-gate]', featureKey, err.message);
    // Sem schema SaaS ainda → permite tudo (modo legado Ícaro)
    _cache.set(featureKey, true);
    return true;
  }
}

class ZzyFeatureGate extends HTMLElement {
  async connectedCallback() {
    const featureKey = this.getAttribute('feature');
    if (!featureKey) return;
    const allowed = await hasFeature(featureKey);
    if (!allowed) {
      this.innerHTML = `
        <div class="zzy-card" style="text-align:center;padding:32px">
          <div style="font:600 16px/1 var(--zzy-font);color:var(--zzy-text);margin-bottom:8px">Recurso não disponível no seu plano</div>
          <div style="font:400 13px/1.4 var(--zzy-font);color:var(--zzy-text-mute);margin-bottom:16px">${featureKey}</div>
          <a class="zzy-btn" href="https://app.zzyon.com/upgrade">Fazer upgrade</a>
        </div>
      `;
    }
  }
}
customElements.define('zzy-feature-gate', ZzyFeatureGate);
